import type { TEntityLanguages } from 'entities/languages'
import { TaxonomyLanguages } from 'generated/graphql'

export const TAXONOMY_LANGUAGES_BY_KEY: Record<TEntityLanguages, TaxonomyLanguages> = {
  all: TaxonomyLanguages.All,
  por: TaxonomyLanguages.Por,
  eng: TaxonomyLanguages.Eng,
  spa: TaxonomyLanguages.Spa,
}
